<template>
  <div
    ref="subBody"
    class="container"
    :style="{width: openType === 'wechat' ? 'calc(100% - env(safe-area-inset-left) - env(safe-area-inset-right))' : '100%'}"
  >
    <div class="header">
      <div v-if="openType === 'app'" @click="goBack" class="back"></div>
      <div v-else style="width:70px;height:30px"></div>
      <div class="header-center">
        <div ref="avatar" @click="handleAvatarPopup" class="avatar-wrap">
          <img v-if="avatar" :src="avatar" />
          <img v-else src="https://image.co-study.com.cn/web/answer-game/default-avatar.png" />
        </div>
        <div
          ref="energy"
          @click="handleEnergyPopup"
          class="energy"
        >{{propertyInfo.power_count > 9999 ? (propertyInfo.power_count / 10000).toFixed(1) + 'w' : propertyInfo.power_count}}</div>
        <div
          ref="coBi"
          @click="handleCoBiPopup"
          class="co-bi"
        >{{propertyInfo.coin_count > 9999 ? (propertyInfo.coin_count / 10000).toFixed(1) + 'w' : propertyInfo.coin_count}}</div>
        <div
          ref="coZuan"
          @click="handleCoZuanPopup"
          class="co-zhuan"
        >{{propertyInfo.jewel_count > 9999 ? (propertyInfo.jewel_count / 10000).toFixed(1) + 'w' : propertyInfo.jewel_count}}</div>
      </div>
      <div class="logo"></div>
    </div>

    <div class="left">
      <img
        @click="rankingPopup = true, leftSelectIndex = 1"
        :src="leftSelectIndex == 1 ? 'https://image.co-study.com.cn/web/answer-game/ranking-s.png' : 'https://image.co-study.com.cn/web/answer-game/ranking.png'"
      />
      <router-link replace to="/questions">
        <img
          @click="leftSelectIndex = 2"
          :src="leftSelectIndex == 2 ? 'https://image.co-study.com.cn/web/answer-game/question-bank-s.png' : 'https://image.co-study.com.cn/web/answer-game/question-bank.png'"
        />
      </router-link>
      <img
        @click="handleGradePopup"
        :src="leftSelectIndex == 3 ? 'https://image.co-study.com.cn/web/answer-game/grade-s.png' : 'https://image.co-study.com.cn/web/answer-game/grade.png'"
      />
    </div>

    <div class="right">
      <div v-if="openType !== 'app'" @click="goLoad" class="confirm">
        <img class="to-load" src="https://image.co-study.com.cn/web/answer-game/co-study.png" />
      </div>
      <div v-if="openType !== 'app'" @click="goAboutUs">
        <img class="about-us" src="https://image.co-study.com.cn/web/answer-game/about-us.png" />
      </div>
      <!-- <img ref="code" @click="handleCodePopup" class="code" src="../assets/image/code.png" /> -->
      <div @click="rulePopup = true" class="rule">
        <img src="https://image.co-study.com.cn/web/answer-game/rule.png" />
      </div>
    </div>

    <div class="main">
      <div class="pk-wrap">
        <div class="pk" ref="invitation" @click="handlePk">
          <img src="../assets/image/invite-text.png" />
        </div>
        <div class="pk" @click="handleMatch">
          <img src="../assets/image/match-text.png" />
        </div>
      </div>
      <!-- <img
        ref="invitation"
        @click="handlePk"
        class="pk"
        src="https://image.co-study.com.cn/web/answer-game/main-pk.png"
      />-->
      <img class="copyright" src="https://image.co-study.com.cn/web/answer-game/copyright.png" />
    </div>

    <ranking v-if="rankingPopup" @close="rankingPopup = false, leftSelectIndex = 0"></ranking>
    <grade v-if="gradePopup" @close="gradeClose"></grade>
    <avatar
      v-if="avatarPopup"
      :position="avatarPosition"
      @resize="handleAvatarPopup"
      @change="changeName"
      @close="avatarPopup = false"
    ></avatar>
    <change-name v-if="changeNamePopup" @close="changeNamePopup = false"></change-name>
    <energy-rule
      v-if="energyRulePopup"
      :position="energyPosition"
      @buy="energyBuyPopup = true, energyRulePopup = false"
      @close="energyRulePopup = false"
    ></energy-rule>
    <energy-buy
      v-if="energyBuyPopup"
      :position="energyPosition"
      @buy="energyBuyPopup = false, getPropertyInfo()"
      @rule="energyBuyPopup = false, energyRulePopup = true"
      @close="energyBuyPopup = false"
    ></energy-buy>
    <co-bi :position="coBiPosition" v-if="coBiPopup" @close="coBiPopup = false"></co-bi>
    <co-zuan v-if="coZuanPopup" :position="coZuanPosition" @close="coZuanPopup = false"></co-zuan>
    <Code v-if="codePopup" :position="codePosition" @close="codePopup = false"></Code>
    <login-type
      v-if="loginTypePopup"
      :type="openType"
      @close="loginTypePopup = false"
      @choose="chooseLoginType"
    ></login-type>
    <mobile-login
      v-if="mobileLoginPopup"
      @success="mobileLoginPopup = false"
      @close="mobileLoginPopup = false"
      :mobileMessage="mobileMessage"
    ></mobile-login>
    <mobile-send-code
      v-if="mobileSendCodePopup"
      @close="mobileSendCodePopup = false"
      @success="sendCodeSucccess"
    ></mobile-send-code>
    <invitation
      v-if="invitationPopup"
      :position="invitationPosition"
      @invitation="goPlay"
      @close="invitationPopup = false"
    ></invitation>
    <rule
      v-if="rulePopup"
      @select="rulePopup = false, ruleToGrade = true, gradePopup = true"
      @questions="$router.replace({path: '/questions', query: {ruleToQuestion: 'true'}})"
      @invitation="handlePk"
      @match="handleMatch"
      @close="rulePopup = false"
    ></rule>
    <confirm
      v-if="confirmPopup"
      :btnType="btnType"
      :title="confirmTitle"
      @select="confirmToSelect"
      @load="goLoad"
      @close="confirmPopup = false"
    ></confirm>
    <!-- <co-study v-if="coStudyPopup" @close="coStudyPopup = false"></co-study> -->
    <share-tip v-if="shareTipPopup" @close="shareTipPopup = false"></share-tip>
  </div>
</template>

<script>
import { ShareTip, Avatar, ChangeName, CoBi, Code, Confirm, CoZuan, EnergyBuy, EnergyRule, Grade, Invitation, LoginType, MobileLogin, MobileSendCode, Ranking, Rule } from '../components/index'

import Model from '../model'
import Websocket from '../util/websocket.js'
import { mapGetters } from 'vuex'
import Utils from '../util/util'
import Config from '../config'
import SocketApi from '../config/socketApi'

export default {
  name: 'Home',
  components: {
    Ranking,
    Grade,
    Avatar,
    EnergyRule,
    EnergyBuy,
    CoBi,
    CoZuan,
    Code,
    LoginType,
    MobileLogin,
    MobileSendCode,
    ChangeName,
    Invitation,
    Rule,
    Confirm,
    // CoStudy,
    ShareTip
  },
  data() {
    return {
      rankingPopup: false,   //  排行榜弹窗
      gradePopup: false,    //  年级弹窗
      avatarPopup: false,    //  头像弹窗
      energyRulePopup: false,    //  体力规则弹窗
      energyBuyPopup: false,    //  体力购买弹窗
      coBiPopup: false,    //  Co币弹窗
      coZuanPopup: false,    //  Co钻弹窗
      codePopup: false,    //  二维码弹窗
      loginTypePopup: false,    //  选择登录方式弹窗
      mobileLoginPopup: false,    //  手机登录弹窗
      mobileSendCodePopup: false,    //  手机登录发送验证码弹窗
      changeNamePopup: false,    //   修改姓名弹窗
      invitationPopup: false,   //   拉人pk弹窗
      rulePopup: false,   //  规则弹窗
      confirmPopup: false,   //  确认弹窗
      // coStudyPopup: true,   //  app邀请弹窗
      shareTipPopup: false,   //  提示分享弹窗
      ruleToGrade: false,
      confirmTitle: '',
      openType: '',
      mobileMessage: {},
      avatarPosition: {},
      energyPosition: {},
      invitationPosition: {},
      coBiPosition: {},
      coZuanPosition: {},
      codePosition: {},
      propertyInfo: {},
      avatar: '',
      timestamp: '',
      nonceStr: '',
      signature: '',
      leftSelectIndex: 0,
      btnType: '',
      inviteType: '',
      isLocked: false
    }
  },
  mounted() {
    if (this.$route.query.ruleToQuestion) this.rulePopup = true
    this.openType = Utils.getOpenType()   //  打开方式
    // const isIosOrAndroid = Utils.isIosOrAndroid()
    // if (this.openType === 'app') {
    //   const params = {
    //     show: false
    //   }
    //   if (isIosOrAndroid === 'android') {
    //     window.Android.showNavigation(JSON.stringify(params))
    //   } else {
    //     window.webkit.messageHandlers.showNavigation.postMessage(JSON.stringify(params))
    //   }
    // }
    this.setKeyboard()   //  全键盘抬起，收起回滚问题
    if (this.access_token) {
      this.getUserinfo()
    } else {
      this.loginTypePopup = true
    }
    if (this.userinfo) {
      this.loginTypePopup = false
      this.avatar = this.userinfo.avatar
      this.getStageList()
      this.getPropertyInfo()
      this.getParams()
    }
  },
  computed: {
    ...mapGetters(['webData', 'userinfo', 'wechat_token', 'access_token', 'room_id', 'stage_list', 'room_id', 'pkType'])
  },
  watch: {
    // 接收的websocket发来的数据
    webData(data) {
      if (data.state_code === 0 || data.state_code === 7) {
        if (this.pkType === 'invite') {
          this.$router.replace({ path: '/waiting', query: { room_id: this.room_id, invite_type: this.inviteType } })
        } else {
          this.$router.replace({ path: '/waitingMatch', query: { room_id: this.room_id } })
        }
      } else if (data.state_code === 3) {
        this.confirmTitle = '你错过这次对战机会啦，可以自己去邀请别人哦!'
        this.btnType = 1
        this.confirmPopup = true
      } else {
        this.$toast({ message: data.error_msg, className: 'toast-trans' })
      }
    },
    // 用户信息
    userinfo(data) {
      if (data) {
        this.loginTypePopup = false
        this.avatar = this.userinfo.avatar
        this.getStageList()
        this.getPropertyInfo()
        this.getParams()
        if (this.room_id) {
          this.sendWebSocket(`${SocketApi.invite}${this.room_id}/${data.id}`)
        }
      }
    }
  },
  methods: {
    //  返回，只有在app中打开有，判断是ios还是android，调起原生方法
    goBack() {
      const isIosOrAndroid = Utils.isIosOrAndroid()
      if (isIosOrAndroid === 'android') {
        try {
          window.Android.goBack()
        } catch (e) {
          this.$toast({ message: '调用失败', className: 'toast-trans' })
        }
      } else if (isIosOrAndroid === 'ios') {
        try {
          window.webkit.messageHandlers.goBack.postMessage(JSON.stringify({}))
        } catch (e) {
          this.$toast({ message: '调用失败', className: 'toast-trans' })
        }
      }
    },
    // 输入框失焦时，页面回滚到原来位置（针对安卓）
    setKeyboard() {
      const originalHeight = document.documentElement.clientHeight || document.body.clientHeight
      window.addEventListener('focusout', () => {
        window.scrollTo(0, 0)
      })
      window.addEventListener('resize', () => {
        if (document.activeElement.tagName === 'INPUT') {
          window.setTimeout(() => {
            document.activeElement.scrollIntoViewIfNeeded()
          }, 100)
        }
        const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
        if (resizeHeight - 0 < originalHeight - 0) {
          //当软键盘弹起，在此处操作
        } else {
          // 安卓生效
          this.$nextTick(() => {
            this.$refs.subBody.scrollIntoView()
          })
        }
      })
    },
    // 弹窗弹起的位置因各个手机大小不同也不同，在点击弹起弹窗时，先获取所需在的位置
    getTopAndLeft(ref) {
      let top, left
      const rect = this.$refs[ref].getBoundingClientRect()
      const clientWidth = document.body.clientWidth
      const clientHeight = document.body.clientHeight
      // if (window.orientation == 180 || window.orientation == 0) {
      if (clientHeight > clientWidth) {
        // 竖屏
        top = document.body.clientWidth - rect.right + rect.width
        left = rect.top + (rect.height / 2)
      }
      // else if (window.orientation == 90 || window.orientation == -90) {
      //   // 横屏
      //   top = rect.top + rect.height
      //   left = rect.left + (rect.width / 2)
      // }
      else {
        top = rect.top + rect.height
        left = rect.left + (rect.width / 2)
      }
      return {
        top,
        left
      }
    },
    // 获取url中所携带的参数，这里主要判断有没有room_id，如果有，则进入相应的房间
    async getParams() {
      const url = window.location.href.split('#')[1]
      const params_str = url.split('?')[1]
      if (!params_str) {
        return ''
      }
      const params_arr = params_str.split('&')				//将参数字符串分割为包含多个参数的数组
      var params = {}
      params_arr.forEach(item => {
        params[item.split('=')[0]] = item.split('=')[1]
      })
      const userinfo = await this.userinfo
      if (params.room_id) {
        this.$store.commit('setPkType', 'invite')
        this.$store.commit('setRoomId', params.room_id)
        this.sendWebSocket(`${SocketApi.invite}${params.room_id}/${userinfo.id}`)
      }
    },
    // 获取用户信息
    async getUserinfo() {
      const res = await Model.getUserinfo()
      if (res && res.data) {
        this.$store.commit('setUserinfo', res.data)
      } else {
        localStorage.removeItem('access_token')
        this.loginTypePopup = true
      }
    },
    // 获取所选择的年级范围
    async getStageList() {
      const res = await Model.getStageList()
      this.$store.commit('setStageList', res.data.records)
    },
    // 获取资产信息
    async getPropertyInfo() {
      const res = await Model.getPropertyInfo()
      this.propertyInfo = res.data
      if (res.data.new_user) {
        this.rulePopup = true
      }
    },
    // 弹起年级弹窗
    handleGradePopup() {
      this.getStageList()
      this.leftSelectIndex = 3
      this.gradePopup = true
    },
    // 确认选择
    confirmToSelect() {
      this.confirmPopup = false
      this.getStageList()
      this.leftSelectIndex = 3
      this.gradePopup = true
    },
    // 判断当前是否满足可以pk的条件，1.已选择pk范围。2.有体力值
    isCanPk() {
      // 判断是否选择pk范围，否则弹出去选择pk范围弹窗
      if (this.stage_list.length === 0) {
        this.confirmTitle = '还没有选择pk范围呢，快去选择吧~'
        this.btnType = 3
        this.confirmPopup = true
        return false
      }
      // 判断时候否有体力值，否则弹出toast
      if (this.propertyInfo.power_count < 1) {
        this.$toast({ message: '你今天没有体力值了~', className: 'toast-trans' })
        return false
      }
      return true
    },
    // 点击匹配模式，满足条件则创建或加入相应的房间
    handleMatch() {
      if (this.isLocked) return
      this.isLocked = true
      // setTimeout(() => {
      //   this.isLocked = false
      // }, 2000)
      this.$store.commit('setPkType', 'match')
      // 规则气泡点击去邀请进入，先关闭规则弹窗
      this.rulePopup = false
      if (!this.isCanPk()) {
        this.isLocked = false
        return
      }
      this.createMatchRoom()
    },
    // 点击邀请模式
    handlePk() {
      this.$store.commit('setPkType', 'invite')
      // 规则气泡点击去邀请进入，先关闭规则弹窗
      this.rulePopup = false
      if (!this.isCanPk()) return
      // 判断网页打开方式，在浏览器中则直接创建房间，否则弹出邀请弹窗
      if (this.openType === 'browser') {
        this.createRoom()
      } else {
        this.invitationPopup = false
        this.invitationPosition = this.getTopAndLeft('invitation')
        this.invitationPopup = true
      }
    },

    goPlay(e) {
      // 不在APP内打开，选择小纸条邀请时弹出提示去下载弹窗
      if (e.type === 'app' && this.openType !== 'app') {
        this.invitationPopup = false
        this.confirmTitle = '需要下载CoStudy APP，才可以传小纸条邀请自习室里面的小伙伴哦，现在去下载吧。'
        this.btnType = 4
        this.confirmPopup = true
        return
      }
      // 创建房间
      this.inviteType = e.type
      this.createRoom()
    },
    // 创建匹配的房间
    async createMatchRoom() {
      try {
        const res = await Model.createMatchRoom({
          stage_list: this.stage_list
        })
        if (!res) {
          this.isLocked = false
          return
        }
        const room_id = res.data.room_id
        const user_id = res.data.user_id
        this.$store.commit('setRoomId', room_id)
        // 建立websocket连接
        await this.sendWebSocket(`${SocketApi.match}${room_id}/${user_id}`)
        setTimeout(() => {
          this.isLocked = false
        }, 2000)
      } catch (e) {
        this.isLocked = false
      }
    },
    // 创建房间
    async createRoom() {
      const res = await Model.createRoom({
        stage_list: this.stage_list
      })
      if (!res) {
        this.isLocked = false
        return
      }
      const room_id = res.data.room_id
      const user_id = res.data.user_id
      this.$store.commit('setRoomId', room_id)
      // 建立websocket连接
      await this.sendWebSocket(`${SocketApi.invite}${room_id}/${user_id}`)
      this.isLocked = false
      // const isIosOrAndroid = Utils.isIosOrAndroid()
      // const params = {
      //   url: `${Config.baseURL}#/index?room_id=${room_id}`
      // }
      // if (this.openType === 'app') {
      //   if (type === 'wechat') {
      //     if (isIosOrAndroid === 'android') {
      //       try {
      //         window.Android.WXShare(JSON.stringify(params))
      //       } catch (e) {
      //         // console.log('调用安卓失败')
      //         // console.log(e)
      //       }
      //     } else {
      //       window.webkit.messageHandlers.WXShare.postMessage(JSON.stringify(params))
      //     }
      //   } else if (type === 'qq') {
      //     // TODO 方便app调试
      //     if (isIosOrAndroid === 'android') {
      //       window.Android.QQShare(JSON.stringify(params))
      //       // const share = {
      //       //   url:'http://www.co-study.com.cn/index',
      //       //   results:80
      //       // }
      //       // window.Android.shareResults(JSON.stringify(share))
      //     } else {
      //       window.webkit.messageHandlers.QQShare.postMessage(JSON.stringify(params))
      //       // const share = {
      //       //   url:'http://www.co-study.com.cn/index',
      //       //   results:80
      //       // }
      //       // window.webkit.messageHandlers.shareResults.postMessage(JSON.stringify(share))
      //     }
      //   } else if (type === 'app') {
      //     //app邀请弹窗
      //     // console.log('打开app邀请弹窗')
      //     // this.coStudyPopup = true
      //     this.inviteTypeApp = true
      //   }
      // }
    },
    // 建立websocket连接
    sendWebSocket(wsuri) {
      try {
        new Websocket(wsuri)
      } catch (err) {
        console.log(err)
      }
    },
    // 弹起头像弹窗
    handleAvatarPopup() {
      this.avatarPopup = false
      this.avatarPosition = this.getTopAndLeft('avatar')
      this.avatarPopup = true
    },
    // 弹起能量弹窗
    handleEnergyPopup() {
      this.energyPosition = this.getTopAndLeft('energy')
      this.energyBuyPopup = true
    },
    // 弹起co币弹窗
    handleCoBiPopup() {
      this.coBiPosition = this.getTopAndLeft('coBi')
      this.coBiPopup = true
    },
    // 弹起co钻弹窗
    handleCoZuanPopup() {
      const openType = Utils.getOpenType()
      if (openType === 'app') {
        const isIosOrAndroid = Utils.isIosOrAndroid()
        if (isIosOrAndroid === 'android') {
          window.Android.goATM()
        } else {
          window.webkit.messageHandlers.goATM.postMessage('')
        }
      } else {
        this.coZuanPosition = this.getTopAndLeft('coZuan')
        this.coZuanPopup = true
      }
    },
    // 弹起二维码弹窗，目前在该页面不需要
    // handleCodePopup() {
    //   this.codePosition = this.getTopAndLeft('code')
    //   this.codePopup = true
    // },
    // 选择登陆方式，手机号？微信？qq？然后做出相应的处理
    chooseLoginType(type) {
      localStorage.clear()
      if (type === 'mobile') {
        this.loginTypePopup = false
        this.mobileSendCodePopup = true
      }
      const url = window.location.href.split('#')[1] || ""
      const params_str = url.split('?')[1] || ""
      const params_arr = params_str.split('&')				//将参数字符串分割为包含多个参数的数组
      var params = {}
      params_arr.forEach(item => {
        params[item.split('=')[0]] = item.split('=')[1]
      })
      let redirect_uri
      if (params.room_id) {
        redirect_uri = encodeURIComponent(`${Config.baseURL}#/index?room_id=${params.room_id}`)
      } else {
        redirect_uri = encodeURIComponent(`${Config.baseURL}#/index`)
      }
      if (type === 'wechat') {
        // const redirect_uri = encodeURIComponent('http://www.co-study.com.cn/index')
        // const redirect_uri = encodeURIComponent(location.href.split('#')[0])
        const appid = Config.wechatAppid
        const scope = 'snsapi_userinfo'
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=login#wechat_redirec`
        location.href = url
      }
      if (type === 'qq') {
        // const redirect_uri = encodeURIComponent(`${Config.baseURL}#/index`)
        const appid = Config.qqAppid
        const scope = 'get_user_info'
        const url = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${appid}&scope=${scope}&redirect_uri=${redirect_uri}&state=state`
        // const url = `https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=${appid}&scope=${scope}&redirect_uri=${redirect_uri}&state=state`
        location.href = url
      }
    },
    // 成功发送验证码，弹起需要输入验证码的登录弹窗
    sendCodeSucccess(val) {
      this.mobileMessage = val
      this.mobileSendCodePopup = false
      this.mobileLoginPopup = true
    },
    // 修改名字
    changeName() {
      this.avatarPopup = false
      this.changeNamePopup = true
    },
    // 关于我们
    goAboutUs() {
      // const isIosOrAndroid = Utils.isIosOrAndroid()
      // if (this.openType === 'app') {
      //   const params = {
      //     show: true
      //   }
      //   if (isIosOrAndroid === 'android') {
      //     window.Android.showNavigation(JSON.stringify(params))
      //   } else {
      //     window.webkit.messageHandlers.showNavigation.postMessage(JSON.stringify(params))
      //   }
      // }
      location.href = "https://mp.weixin.qq.com/s/6aBlFqtM0HSQnvQKSfaTXA"
    },
    // 去下载
    goLoad() {
      location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.costudy.costudy"
    },
    // 关闭选择pk范围的弹窗
    gradeClose() {
      this.gradePopup = false
      this.leftSelectIndex = 0
      if (this.ruleToGrade) {
        this.rulePopup = true
        this.ruleToGrade = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function px2rem($px) {
  $rem: 375px;
  @return ($px/$rem) + rem;
}

@media screen and (orientation: portrait) {
  @media screen and (min-width: 768px) {
    .header-right {
      width: 85% !important;
    }
    .energy {
      margin-right: px2rem(10px) !important;
    }
    .energy,
    .co-bi,
    .co-zhuan {
      width: px2rem(76px) !important;
      height: px2rem(26px) !important;
      font-size: px2rem(12px);
      color: #534831;
    }
  }
}

@media screen and (orientation: landscape) {
  @media screen and (min-width: 1024px) {
    .header-right {
      width: 85% !important;
    }
    .energy {
      margin-right: px2rem(10px) !important;
    }
    .energy,
    .co-bi,
    .co-zhuan {
      width: px2rem(76px) !important;
      height: px2rem(26px) !important;
      font-size: px2rem(12px);
      color: #534831;
    }
  }
}

.container {
  .header {
    width: 100%;
    box-sizing: border-box;
    padding: 0 px2rem(22px) 0 px2rem(17px);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-center {
      display: flex;
      align-items: center;
    }

    .back {
      width: px2rem(73px);
      height: px2rem(30px);
      background: url("https://image.co-study.com.cn/web/answer-game/back.png")
        no-repeat;
      background-size: auto 100%;
    }

    .avatar-wrap {
      width: px2rem(36px);
      height: px2rem(36px);
      border-radius: 50%;
      border: px2rem(2px) solid #ede4d1;
      background: #ede4d1;
      margin-right: px2rem(52px);
      overflow: hidden;

      img {
        width: px2rem(38px);
        height: px2rem(38px);
        transform: translate(px2rem(-1px), px2rem(-1px));
      }
    }

    .energy {
      background: url("https://image.co-study.com.cn/web/answer-game/energy.png");
      margin-right: px2rem(26px);
    }

    .co-bi {
      background: url("https://image.co-study.com.cn/web/answer-game/co-bi.png");
      margin-right: px2rem(26px);
    }

    .co-zhuan {
      background: url("https://image.co-study.com.cn/web/answer-game/co-zhuan.png");
    }
    .energy,
    .co-bi,
    .co-zhuan {
      width: px2rem(82px);
      height: px2rem(28px);
      line-height: px2rem(28px);
      background-size: 100%;
      font-weight: 600;
      font-size: px2rem(12px);
      color: #534831;
      text-indent: px2rem(25px);
    }

    .logo {
      width: px2rem(73px);
      height: px2rem(46px);
      background: url("https://image.co-study.com.cn/web/answer-game/logo.png");
      background-size: 100% 100%;
    }
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 66%;
    position: absolute;
    left: px2rem(16px);
    bottom: px2rem(30px);

    img {
      width: px2rem(46px);
      height: px2rem(62px);
    }
  }

  .right {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    position: absolute;
    right: px2rem(6px);
    bottom: px2rem(36px);

    .to-load {
      width: px2rem(28px);
      height: px2rem(28px);
    }

    .about-us {
      width: px2rem(29px);
      height: px2rem(102px);
      margin: px2rem(30px) 0 px2rem(20px);
    }

    .code {
      width: px2rem(27px);
      height: px2rem(27px);
      margin: px2rem(40px) 0 px2rem(10px);
    }

    .rule {
      width: px2rem(40px);
      height: px2rem(40px);
      display: flex;
      justify-content: flex-end;
      align-items: center;

      img {
        width: px2rem(25px);
        height: px2rem(12px);
        margin-right: px2rem(3px);
      }
    }
  }

  .main {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;

    .pk-wrap {
      display: flex;

      .pk {
        width: px2rem(146px);
        height: px2rem(62px);
        background-image: url("../assets/image/main-pk-bg.png");
        background-size: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: px2rem(64px);
          margin-top: px2rem(5px);
        }
      }

      .pk:nth-child(1) {
        margin-right: px2rem(13px);
      }
    }

    .copyright {
      width: px2rem(113px);
      height: px2rem(12px);
      margin: px2rem(18px) 0 px2rem(10px);
    }
  }
}
</style>
